import React from "react";

const Reports = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">System Reports</h1>
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b">
          <h2 className="text-xl font-semibold">Available Reports</h2>
        </div>
        <div className="p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="border rounded-lg p-4">
              <h3 className="font-semibold">Performance Report</h3>
              <p className="text-sm text-gray-600 mt-2">
                Detailed analysis of system performance metrics
              </p>
              <button className="mt-4 bg-blue-500 text-white px-4 py-2 rounded">
                Generate Report
              </button>
            </div>
            <div className="border rounded-lg p-4">
              <h3 className="font-semibold">Usage Statistics</h3>
              <p className="text-sm text-gray-600 mt-2">
                User activity and resource utilization data
              </p>
              <button className="mt-4 bg-blue-500 text-white px-4 py-2 rounded">
                Generate Report
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;
